import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import StaffLayout from '../../components/StaffLayout';
import StatementView from '../../components/StatementView';
import { DateRangeFilter, useDateRange } from '../../components/DateRangeFilter';
import { Label } from '../../components/ui/label';
import { CustomerAccountSelect } from '../../components/CustomerAccountSelect';
import { useCustomers } from '../../hooks/useCustomers';
import { useApi } from '../../lib/api';
import { STAFF_TABS } from '../../lib/constants';
import { useAuth } from '../../context/AuthContext';
import { CurrencySwitcher, useStaffCurrency } from '../../components/CurrencySwitcher';

export default function AccountStatementPage() {
  const { user } = useAuth();
  const [currency, setCurrency] = useStaffCurrency();
  const [params] = useSearchParams();
  const { data: customers } = useCustomers();
  const [accountNo, setAccountNo] = useState(params.get('accountNo') || '');
  const dates = useDateRange();
  const { data, error } = useApi(accountNo ? `/statement?accountNo=${encodeURIComponent(accountNo)}&${dates.query}&currency=${currency}` : '/shop');
  const stmt = !dates.invalid && !error && data?.customer?.accountNo === accountNo && data.currency === currency ? data : null;
  return <StaffLayout tabs={STAFF_TABS}><h1 data-testid="staff-statement-heading" className="text-2xl font-semibold mb-6 print:hidden">Account Statement</h1>
    <div className="mb-5"><CurrencySwitcher currency={currency} onChange={setCurrency} /></div>
    <div className="space-y-5 border-b border-slate-200 pb-6 mb-6 print:hidden"><div className="space-y-2 max-w-lg"><Label htmlFor="statement-account">Customer account</Label><CustomerAccountSelect id="statement-account" customers={customers} value={accountNo} onValueChange={setAccountNo} prefix="statement-account" /></div><DateRangeFilter {...dates} /></div>
    {error && <p data-testid="staff-statement-error" role="alert" className="text-rose-700">{error}</p>}
    {stmt ? <StatementView customer={stmt.customer} data={stmt} shopName={user?.shopName} /> : !accountNo && <p data-testid="statement-select-account" className="text-slate-500 py-8">Select a customer.</p>}
  </StaffLayout>;
}